/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eat below your TDEE to lose weight and above it to gain. A deficit or surplus of about 500 kcal per day changes weight by roughly half a kilogram per week.`)
};

const es_bmr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come por debajo de tu GEDT para perder peso y por encima para ganarlo. Un déficit o superávit de unas 500 kcal al día cambia el peso en aproximadamente medio kilo por semana.`)
};

const de_bmr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iss unterhalb deines TDEE, um abzunehmen, und oberhalb davon, um zuzunehmen. Ein Defizit oder Überschuss von etwa 500 kcal pro Tag verändert das Gewicht um rund ein halbes Kilogramm pro Woche.`)
};

const nl_bmr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eet onder je TDEE om af te vallen en erboven om aan te komen. Een tekort of overschot van ongeveer 500 kcal per dag verandert je gewicht met ruwweg een half kilo per week.`)
};

const fr_bmr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mangez en dessous de votre TDEE pour perdre du poids et au-dessus pour en prendre. Un déficit ou surplus d'environ 500 kcal par jour fait varier le poids d'environ un demi-kilo par semaine.`)
};

const it_bmr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mangia sotto il tuo TDEE per dimagrire e sopra per aumentare. Un deficit o un surplus di circa 500 kcal al giorno modifica il peso di circa mezzo chilo a settimana.`)
};

const pt_br2_bmr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coma abaixo do seu GET para emagrecer e acima dele para ganhar peso. Um déficit ou superávit de cerca de 500 kcal por dia altera o peso em aproximadamente meio quilo por semana.`)
};

const pt_bmr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coma abaixo do seu TDEE para perder peso e acima para ganhar. Um défice ou excedente de cerca de 500 kcal por dia altera o peso em cerca de meio quilo por semana.`)
};

const ja_bmr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TDEEより少なく食べると減量し、多く食べると増量します。1日約500kcalの過不足で、週あたり約0.5kgの体重変化が起こります。`)
};

const zh_bmr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摄入低于 TDEE 可减重，高于 TDEE 可增重。每日约 500 千卡的热量缺口或盈余，大约会带来每周半公斤的体重变化。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq_a4", locale)
	if (locale === "en") return en_bmr_faq_a4(inputs)
	if (locale === "es") return es_bmr_faq_a4(inputs)
	if (locale === "de") return de_bmr_faq_a4(inputs)
	if (locale === "nl") return nl_bmr_faq_a4(inputs)
	if (locale === "fr") return fr_bmr_faq_a4(inputs)
	if (locale === "it") return it_bmr_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq_a4(inputs)
	if (locale === "pt") return pt_bmr_faq_a4(inputs)
	if (locale === "ja") return ja_bmr_faq_a4(inputs)
	return zh_bmr_faq_a4(inputs)
};